// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselService\MarineTrafficServiceSearchResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { MarineTrafficServiceVessel, MarineTrafficServiceVesselData, MarineTrafficServiceVesselOptions } from 'data/models/MarineTrafficServiceVessel';

// MarineTrafficServiceSearchData is the class that MarineTrafficServiceSearch serializes to/from
export interface MarineTrafficServiceSearchData {
    IMO : number | null;
    MMSID : number | null;
	
    Results : MarineTrafficServiceVesselData[] | null;
	
}

// MarineTrafficServiceSearchOptions is the class which may be passed to the MarineTrafficServiceSearch constructor to define optional initial data values
export interface MarineTrafficServiceSearchOptions {
    IMO : number | null;
    MMSID : number | null;
	
    Results? : MarineTrafficServiceVesselOptions[] | null;
	
}

export class MarineTrafficServiceSearch {
    public IMO : DataSignal<number | null>;
    public MMSID : DataSignal<number | null>;
	
    public Results : SDataArray<MarineTrafficServiceVessel>;
	

    constructor();
    constructor(data : MarineTrafficServiceSearchOptions);
    constructor(data: MarineTrafficServiceSearchOptions | null = null) {
        this.IMO = jsonableObservable(S.value<number | null>(data && data.IMO !== undefined ? data.IMO : null));
        this.MMSID = jsonableObservable(S.value<number | null>(data && data.MMSID !== undefined ? data.MMSID : null));
	    
        this.Results = SArray<MarineTrafficServiceVessel>([]);
	    
    }

    static key(obj : MarineTrafficServiceSearch) {
        return (obj.IMO() === null ? NaN : obj.IMO()!) + '\u2618' + (obj.MMSID() === null ? NaN : obj.MMSID()!);
    }
    
    static dataKey(obj : MarineTrafficServiceSearchOptions) {
        return (obj.IMO === null ? NaN : obj.IMO) + '\u2618' + (obj.MMSID === null ? NaN : obj.MMSID);
    }

    static update(obj : MarineTrafficServiceSearch, data : MarineTrafficServiceSearchOptions) {
        S.freeze(() => {
            if (data.IMO !== undefined) obj.IMO(data.IMO);
            if (data.MMSID !== undefined) obj.MMSID(data.MMSID);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/MarineTrafficServiceSearch.ts